import { BaseModel } from '@core/data-access';
import { Exclude, Expose, Type } from 'class-transformer';
import { IDocument } from '../interface';
import { ContractModel } from './contract.model';

@Exclude()
export class DocumentModel extends BaseModel implements IDocument {
  @Expose() id!: number;
  @Expose() role!: string;
  @Expose() @Type(() => ContractModel) contract!: ContractModel;
  @Expose() accessToken!: string;
}
